exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".top-5f9678e4{min-height:100vh;position:relative;display:flex}.sidebar-6cb2064a{width:400px;min-height:100vh;box-shadow:0 1px 1px 0 rgba(0,0,0,0.08),0px 1px 6px 1px rgba(0,0,0,0.08);position:relative;z-index:2;padding:20px 20px}.content-043865f5{flex:1 1;min-width:0;z-index:1}\n", ""]);

// Exports
exports.locals = {
	"top": "top-5f9678e4",
	"sidebar": "sidebar-6cb2064a",
	"content": "content-043865f5"
};